export default "/static/media/icon-slider-left.ad9f4c37.svg";